<template>
  <div
    class="main scroll"
    ref="scroll"
  >
    <div class="scroll-wrapper">
    <div class="head-title">
      <div class="left">
        <div class="main blue">
          常用工具
        </div>
      </div>
    </div>
    <div class="tool-section">
      <div class="ewmbox flex1">
        <div class="name">关注观米公众号了解最新使用技巧及动态</div>
        <div class="msg">
          <img class="ewm" :src="require('../assets/ewm.jpg')" alt="" />
          <div @click="previewVisible = true" class="see blue">
            点击查看大图
          </div>
        </div>
      </div>
      <div class="flex1">
        <div class="name">推荐浏览器下载</div>
        <div class="msg">
          <img class="chrome" src="../assets/icon-b-01.png" alt="" />
          <a
            download="../assets/ChromeSetup.exe"
            href="../assets/ChromeSetup.exe"
            class="see blue"
            >点击下载</a
          >
        </div>
      </div>
    </div>

    <div class="head-title">
      <div class="left">
        <div class="main blue">
           字体列表
        </div>
      </div>
    </div>
    <div class="content font">
      <a :href="item.file" download v-for="(item,index) in fontlist" :key="index" class="font-cell">
        <div :style="{fontFamily:item.name}">{{item.name}}</div>
        <!-- <div :style="{fontFamily:item.name}">{{item.file}}</div> -->
      </a>
    </div>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
    >
      <div style="padding:20px">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </div>
    </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      previewVisible: false,
      previewImage: require("../assets/ewm.jpg"),
      fontlist:[]
    };
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    if (this.userInfo) {
      this.getFonts();
    }
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getFonts();
      }
    },
  },
  methods: {
    show(e, id) {
      console.log(e, id);
    },
    getFonts() {
      this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.getFonts,
          headers: { Authorization: this.$store.state.headers },
          data: { limit: 100 ,page:1,uid:18},
        })
          .then((res) => {
            // this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.fontlist = res.data.data.data
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
    }
  },
};
</script>

<style lang="scss" scoped>
.font{
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 30px;
  .font-cell{
    width: 200px;
    cursor: pointer;
    border-radius: 8px;
    background: #eee;
    color: #686868;
    text-align: center;
    font-size: 20px;
    margin: 0  20px 20px 20px;
    line-height: 70px;
  }
}
.tool-section {
  display: flex;
  align-items: flex-start;
  .flex1 {
    flex: 1 1 0%;
    position: relative;
    margin-top: 30px;
    padding-left: 18px;
    .msg{
      height: 120px;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
    }
    .chrome {
      width: 60px;
      margin-right: 20px;
    }
    &::after {
      position: absolute;
      content: "";
      left: 0;
      top: 6px;
      width: 8px;
      height: 8px;
      border-radius: 8px;
      background: #67b0dc;
    }
  }
}
.main {
  height: 100%;
}
.list {
  width: 100%;
  margin-top: 20px;
  .head {
    width: 100%;
    display: flex;
    flex-direction: row;
    .left {
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #f39800;
      color: #fff;
      margin: 0 1px 1px 0;
    }
    .right {
      display: flex;
      flex-direction: row;
      flex: 1 1 0%;
      .cell {
        width: 40px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #f39800;
        color: #fff;
        margin: 0 1px 1px 0;
      }
    }
  }
  .body {
    width: 100%;
    .students {
      display: flex;
      flex-direction: row;
      .left {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #e4eaee;
        color: #898989;
        margin: 0 1px 1px 0;
      }
      .right {
        flex: 1 1 0%;
        display: flex;
        flex-direction: row;
        .cell {
          width: 40px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #e4eaee;
          color: #fff;
          margin: 0 1px 1px 0;
        }
      }
      &.hui .left {
        background: #dce2e6;
      }
      &.hui .right .cell {
        background: #dce2e6;
      }
    }
  }
}
.ewmbox {
  width: 100%;
  padding-left: 18px;
  position: relative;

  .ewm {
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .name {
    color: #898989;
  }
  .msg {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
    height: 120px;
    box-sizing: border-box;
    .txt {
      color: #f39800;
      font-size: 20px;
    }
    .see {
      cursor: pointer;
    }
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addframe {
    width: 175px;
    margin-bottom: 30px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }
  .cell {
    width: 175px;
    height: 120px;
    background: url("../assets/doc.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    padding: 25px 15px 15px 15px;
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-right: 30px;
    .tx {
      width: 92px;
      height: 92px;
      margin-right: 20px;
    }
    &.select {
      border: 3px solid #67b0dc;
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
        }
      }
    }
  }
}
</style>
